import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {MedicalRecordProblemCreateUpdateComponent} from "./medical-record-problem-create-update.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CardModule} from "../../../../../../core/component/card/card.module";
import {FormFieldModule} from "../../../../../../core/component/form-field/form-field.module";
import {CustomDateInputModule} from "../../../../../../../components/common/date/custom-date/custom-date-input/custom-date-input.module";
import {LovValueSelectFilterModule} from "../../../../../../common/lov/lov-value/api/component/lov-value-select-filter/lov-value-select-filter.module";
import {CreateUpdateDefaultModule} from "../../../../../../core/component/create-update-default/create-update-default.module";
import {RichTextEditorModule} from "../../../../../../../components/common/rich-text-editor/rich-text-editor.module";
import {FormArrayInputModule} from "../../../../../../../components/common/form-array/form-array-input/form-array-input.module";
import {PartnerSearchWithCreateAbilityModule} from "../../../../../../partner/common/api/component/partner-search-with-create-ability/partner-search-with-create-ability.module";
import {
    LovValuesSelectFilterModule
} from '../../../../../../common/lov/lov-value/api/component/lov-values-select-filter/lov-values-select-filter.module';
import {
    CheckboxInputModule
} from "../../../../../../../components/common/checkbox/checkbox-input/checkbox-input.module";
import {
    LovValuesChipsAutocompleteModule
} from "../../../../../../common/lov/lov-value/api/component/lov-value-chips-autocomplete/lov-values-chips-autocomplete.module";
import {DialogModule} from "../../../../../../common/dialog/dialog.module";
import {ButtonModule} from "../../../../../../core/component/button/button.module";
import {LoadingModule} from "../../../../../../../components/common/loading/loading.module";
import {CardV2Component} from "../../../../../../core/component/card-v2/card-v2.component";
import {MainModule} from "../../../../../../../apps/luna/main.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CardModule,
        ReactiveFormsModule,
        FormFieldModule,
        CustomDateInputModule,
        LovValueSelectFilterModule,
        CreateUpdateDefaultModule,
        RichTextEditorModule,
        FormArrayInputModule,
        PartnerSearchWithCreateAbilityModule,
        LovValuesSelectFilterModule,
        CheckboxInputModule,
        LovValuesChipsAutocompleteModule,
        DialogModule,
        ButtonModule,
        LoadingModule,
        CardV2Component,
    ],
    declarations: [
        MedicalRecordProblemCreateUpdateComponent,
    ],
    exports: [
        MedicalRecordProblemCreateUpdateComponent
    ],
})
export class MedicalRecordProblemCreateUpdateModule {}
